'use strict';

import { xhrSearch } from "./xhr/xhrSearchResults";
import { EVENT_SEARCH_SUBMIT } from "../MainSearchBar/MainSearchBar";
import { searchResultsElements } from "./elements/searchResultsElements";
import { EVENT_CLICK_MARKER } from "../Map/Map";

export default class SearchResults
{
    constructor(
        mainSearchBar,
        multiLocationMap,
        lat = null,
        lng = null,
        bbox = null,
        what = null,
        where = null,
        distance = null,
        paymentMethod = null,
    ) {
        this.mainSearchBar = mainSearchBar;
        this.multiLocationMap = multiLocationMap;
        this.lat = lat;
        this.lng = lng;
        this.bbox = bbox;
        this.what = what;
        this.where = where;
        this.distance = distance;
        this.paymentMethod = paymentMethod;

        this.elements = searchResultsElements();
        this.searchBarSubmit = this.onSearchBarSubmit.bind(this);
        this.clickMarker = this.onClickMarker.bind(this);
        this.clickTag = this.onClickTag.bind(this);
        this.clickResultTitle = this.onClickResultTitle.bind(this);

        this.addEventListeners();
        this.search(this.what, this.where, this.distance, this.lat, this.lng, this.bbox, this.paymentMethod);
    }

    addEventListeners() {
        this.mainSearchBar.addEventListener(EVENT_SEARCH_SUBMIT, this.searchBarSubmit);
        this.multiLocationMap.addEventListener(EVENT_CLICK_MARKER, this.clickMarker);
    }

    buildSearchResultsTitle() {
        const what = this.what.trim();
        const where = this.where.trim();
        if (what !== '' && where !== '') {
            return `${what} - ${where}`;
        }
        if (what !== '') {
            return what;
        }
        if (where !== '') {
            return where;
        }
        return '';
    }

    drawSearchResults(results) {
        this.elements.searchResultsCount.innerHTML = `${results.length} Resultaten`;
        this.elements.searchResultsTitle.innerHTML = this.buildSearchResultsTitle();
        if (results.length === 0) {
            this.elements.resultsContainer.innerHTML = this.elements.noResultsTemplate.innerHTML;
        } else {
            const template = this.elements.providerLocationTemplate.innerHTML;
            let draw = '';
            let number = 1;
            for (let result of results) {
                const categoriesAndTags = [];
                const paymentMethods = [];
                for (let category of result.categories) {
                    categoriesAndTags.push(this.elements.tag(category));
                }
                for (let tag of result.tags) {
                    categoriesAndTags.push(this.elements.tag(tag));
                }
                for (let paymentMethod of result.paymentMethods) {
                    paymentMethods.push(paymentMethod);
                }
                draw += this.elements.providerLocation(
                    template,
                    result,
                    categoriesAndTags,
                    paymentMethods.length > 0 ? this.elements.paymentMethods(paymentMethods.sort().join(', ')) : '',
                    number,
                    result.image !== '' ? this.elements.image(result.image) : '',
                    result.phone !== '' ? this.elements.phone(result.telephone) : '',
                    result.website !== '' ? this.elements.website(result.website) : '',
                    result.email !== '' ? this.elements.email(result.email) : '',
                    result.image === '' ? 'col-12' : 'col-8',
                    result.location !== null ? (result.location.lat + ',' + result.location.lon) : null
                );
                number++;
            }
            this.elements.resultsContainer.innerHTML = draw;
            this.addEventListenerToTags();
            this.addEventListenerToTitles();
        }
    }

    addEventListenerToTags() {
        const tags = this.elements.tags();
        for (let tag of tags) {
            tag.addEventListener('mousedown', this.clickTag);
        }
    }

    addEventListenerToTitles() {
        const titles = this.elements.titles();
        for (let title of titles) {
            title.addEventListener('mousedown', this.clickResultTitle);
        }
    }

    onSearchBarSubmit(event) {
        const { what, where, distance, lat, lng, bbox, paymentMethod } = event.detail;
        this.multiLocationMap.moveView(bbox.split(','), distance);
        this.search(what, where, distance, lat, lng, bbox, paymentMethod);
        this.updateUrl(what, where, distance, lat, lng, bbox, paymentMethod);
    }

    onClickMarker(event) {
        const searchResult = this.elements.searchResult(event.detail.number);
        this.elements.scrollContainer.scrollTo({top: searchResult.offsetTop, behavior: 'smooth'});
        // For mobile only
        this.elements.scrollContainerSmall.scrollTo({top: searchResult.offsetTop+300, behavior: 'smooth'});
    }

    onClickTag(event) {
        const target = event.currentTarget;
        let value = target.getAttribute('data-tag-value');
        this.mainSearchBar.setWhat(value);
        this.elements.scrollContainer.scrollTo({top: 0});
        this.elements.scrollContainerSmall.scrollTo({top: 0});
    }

    onClickResultTitle(event) {
        const target = event.currentTarget;
        const location = target.getAttribute('data-location').split(',');
        if (location.length > 0) {
            this.multiLocationMap.moveViewLatLng(location[0], location[1]);
        }
    }

    search(what, where, distance, lat, lng, bbox, paymentMethod) {
        this.what = what;
        this.where = where;
        this.paymentMethod = paymentMethod;
        xhrSearch(what, where, distance, lat, lng, bbox, paymentMethod).then(http => {
            this.drawSearchResults(http.response.results);
            this.multiLocationMap.draw(
                http.response.params.bbox,
                http.response.params.distance,
                true
            );
            this.multiLocationMap.updateMarkers(
                http.response.results
            );
        }).catch(http => { console.error(http); });
    }

    updateUrl(what, where, distance, lat, lng, bbox, paymentMethod) {
        const url = encodeURI(`/aanbieders?what=${what}&where=${where}&payment-method=${paymentMethod}`);
        window.history.pushState({}, null, url);
    }
}